import { downgradeComponent } from '@angular/upgrade/static';
import angular from 'angular';
import { CommentPanelComponent } from './comment-panel.component';

export const ngxCommentPanelModule = angular.module('ngxCommentPanelModule', [])
	.directive('ngxCommentPanel', downgradeComponent({ component: CommentPanelComponent }))
	.name;
